// extracted by mini-css-extract-plugin
export default {"customBtn":"Button_customBtn__NJ6St"};